import React from 'react';
import { Popup } from 'semantic-ui-react';
import NameCellContent from './NameCellContent';
import LinkifyWrapper from '../LinkifyWrapper';

const HoverActionButtonsContent = ({
  content,
  href,
  link,
  messageText,
  onClick,
  showUrlLinks,
  showPopup,
}) => {
  if (!content) {
    return (
      <NameCellContent name={messageText}>
        {messageText}
      </NameCellContent>
    );
  }

  if (showUrlLinks) {
    return (
      <LinkifyWrapper properties={{ title: content }}>
        {content}
      </LinkifyWrapper>
    );
  }

  if (showPopup) {
    return (
      <Popup
        content={content}
        wide="very"
        trigger={
          <span className="two-lines-text">{content}</span>
        }
      />
    );
  }

  return (
    <NameCellContent name={content} href={href} onClick={onClick} link={link}>
      {content}
    </NameCellContent>
  );
};

export default HoverActionButtonsContent;
